import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getHeaders } from "../../helpers/getHeaders";
import axios from "../../axios-instance";
import queryString from "query-string";

import ArrowLeft from "../../images/ic-arrow-left.svg";
import ArrowRight from "../../images/ic-arrow-right.svg";
import NewLoader from "../NewLoader/NewLoader";

const Dot = ({ cx, cy }) => (
  <circle
    cx={cx}
    cy={cy}
    r={6}
    fill="#FFF"
    stroke="#6071B5"
    strokeWidth="3px"
  />
);

export const TicketsSalesGraphic = () => {
  const [date, setDate] = useState({
    startDate: moment().subtract(7, "d"),
    endDate: moment(),
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getGraphicData = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const params = {
      startDate: date.startDate.format("YYYY-MM-DD"),
      endDate: date.endDate.format("YYYY-MM-DD"),
    };
    const queryParams = queryString.stringify(params, { encode: false });

    const { data } = await axios.get(`/Events/SaleStats?${queryParams}`, {
      headers: getHeaders(user.token),
    });

    setData(
      data.map((item) => ({
        ...item,
        date: new Date(item.date).getTime(),
      }))
    );
    setLoading(false);
  };

  useEffect(() => {
    getGraphicData();
  }, [date]);

  const handleDate = (action) => {
    switch (action) {
      case "future":
        setDate({
          startDate: date.endDate,
          endDate: moment(date.endDate).add(7, "d"),
        });
        break;
      case "past":
        setDate({
          endDate: date.startDate,
          startDate: moment(date.startDate).subtract(7, "d"),
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="dashboard__graphic">
      <div className="dashboard__card-header">
        <h6 className="dashboard__title">Tickets Sales</h6>
        <div className="dashboard__actions">
          <button
            className="dashboard__actions-btn"
            onClick={() => handleDate("past")}
          >
            <img src={ArrowLeft} alt="Minus Time" />
          </button>
          <p>
            {date.startDate.format("DD MMM YY")} -{" "}
            {moment(date.endDate).subtract(1, "d").format("DD MMM YY")}
          </p>
          <button
            className="dashboard__actions-btn"
            onClick={() => handleDate("future")}
          >
            <img src={ArrowRight} alt="Add Time" />
          </button>
        </div>
      </div>
      {loading ? (
        <NewLoader />
      ) : (
        <ResponsiveContainer width="100%" height={500}>
          <AreaChart data={data}>
            <defs>
              <linearGradient
                id="colorDate"
                x1="282.75"
                y1="-24.3316"
                x2="282.75"
                y2="397.349"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#3C5DE2" stopOpacity="0.29" />
                <stop offset="1" stopColor="#6071B5" stopOpacity="0" />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" tick={<CustomizedAxisTick />} />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip
              labelFormatter={(value) =>
                `Date: ${moment(value).format("DD MMM YY")}`
              }
            />
            <Area
              dot={<Dot />}
              dataKey="amount"
              stroke="#6071B5"
              strokeWidth="4"
              fill="url(#colorDate)"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#666">
        {moment(payload.value).format("ddd")}
      </text>
    </g>
  );
};
